import React from "react";
import styled, { keyframes } from "styled-components";
import { IconBaseProps } from "react-icons";

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

const StyledSpinner = styled("svg")`
  display: block;
  animation: ${rotate} 2s linear infinite;

  & > circle {
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`;

export const SpinnerSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <StyledSpinner
    width={size}
    height={size}
    viewBox="0 0 50 50"
  >
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke={fill}
      strokeWidth="6"
      strokeLinecap="round"
    />
  </StyledSpinner>
);
